import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
import SoFormContainer from '../../components/layout/SoFormContainer';
import CreditCardComponent from './creditCard/Form';

const SoFormStepCardBody = ({ className }) => {
  return (
    <div className={className}>
      <SoFormContainer>
        <CreditCardComponent />
      </SoFormContainer>
    </div>
  );
};

SoFormStepCardBody.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepCardBody)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 0px;
  width: 100%;
  ${SoFormContainer} {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 0px;
    gap: 16px;
    padding: 0px;
  }
  flex-grow: 1;
`;
